__turbopack_context__.v({
  "actions": "collection-big-module__Y-UzjG__actions",
  "copy": "collection-big-module__Y-UzjG__copy",
  "description": "collection-big-module__Y-UzjG__description",
  "fallback": "collection-big-module__Y-UzjG__fallback",
  "frame": "collection-big-module__Y-UzjG__frame",
  "media": "collection-big-module__Y-UzjG__media",
  "picture": "collection-big-module__Y-UzjG__picture",
  "pill": "collection-big-module__Y-UzjG__pill",
  "section": "collection-big-module__Y-UzjG__section",
  "stage": "collection-big-module__Y-UzjG__stage",
  "title": "collection-big-module__Y-UzjG__title",
  "video": "collection-big-module__Y-UzjG__video",
});
